(function() {
  'use strict';

  function fillProductGridRows() {
    var grids = document.querySelectorAll('ul.product-grid, ul.grid.product-grid');
    grids.forEach(function(grid) {
      // Remove any previously added placeholders
      grid.querySelectorAll('.hlds-grid-placeholder').forEach(function(el) { el.remove(); });

      // Get all visible, non-block items (product cards only)
      var items = Array.from(grid.children).filter(function(el) {
        return getComputedStyle(el).display !== 'none' 
          && !el.classList.contains('grid-item-block');
      });

      if (items.length === 0) return;

      // Detect columns from rendered widths
      var gridW = grid.getBoundingClientRect().width;
      var itemW = items[0].getBoundingClientRect().width;
      if (itemW <= 0) return;

      var cols = Math.round(gridW / itemW);
      if (cols <= 1) return;

      // Walk through items tracking row position
      // When we hit a grid-item-block, fill the current row then continue
      var pos = 0; // current column position (0-indexed)
      var allChildren = Array.from(grid.children).filter(function(el) {
        return getComputedStyle(el).display !== 'none';
      });

      allChildren.forEach(function(el) {
        if (el.classList.contains('grid-item-block')) {
          // This full-width block resets the row — fill before it if needed
          if (pos > 0) {
            var needed = cols - pos;
            for (var i = 0; i < needed; i++) {
              var ph = document.createElement('li');
              ph.className = 'grid-item hlds-grid-placeholder';
              ph.setAttribute('aria-hidden', 'true');
              grid.insertBefore(ph, el);
            }
          }
          pos = 0; // block takes full row, next item starts fresh
        } else {
          pos = (pos + 1) % cols;
        }
      });

      // Fill the final incomplete row
      if (pos > 0) {
        var finalNeeded = cols - pos;
        for (var j = 0; j < finalNeeded; j++) {
          var finalPh = document.createElement('li');
          finalPh.className = 'grid-item hlds-grid-placeholder';
          finalPh.setAttribute('aria-hidden', 'true');
          grid.appendChild(finalPh);
        }
      }
    });
  }

  // Run on load and on resize
  function init() {
    fillProductGridRows();
    window.addEventListener('resize', function() {
      clearTimeout(window._hldsResizeTimer);
      window._hldsResizeTimer = setTimeout(fillProductGridRows, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();